import MakerJs, { IModel } from "makerjs"

export function createDXF(paths: string[]) {
  const models = paths.map(p => MakerJs.importer.fromSVGPathData(p))
  const model: IModel = {
    models: {}
  }
  models.forEach((m, i) => model.models![i] = m)
  MakerJs.model.scale(model, 1e-3)
  return MakerJs.exporter.toDXF(model, { units: 'mm' })
}